export default __webpack_public_path__ + "static/forge-b63f5e78d9d2bd5e40394bd979de6994.png";